import { BookingsState } from '../../../../@types/redux/store/BookingsTypes';

const initialState: BookingsState = {
  bookings: [],
  bookingViolations: null,
  preSignupBooking: null,
};
export default initialState;
